import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Button } from 'antd';
import { Switch, Route } from 'react-router-dom';
import Link from '../components/general/Link';
import ClientDashboardPage from '../pages/ClientDashboardPage';
import NewRetainerClientMeetingMinutesForm from '../forms/NewRetainerClientMeetingMinutesForm';
import DiscussionGroupPage from '../pages/DiscussionGroupPage';

import QUERY from '../graphql/queries/retainerClientByIdQuery.graphql';
import RetainerClientDocuments from '../pages/RetainerClientDocuments';

const RetainerClientLayout = ({ data, match }) => {
  if (data.loading) {
    return <Spin />;
  }
  const { retainerClient } = data;
  const { path, url } = match;
  return (
    <div>
      <h1 style={{ marginBottom: 10 }}>
        <Link to={url}>{retainerClient.name}</Link>
      </h1>
      <div style={{ marginBottom: 20 }}>
        <Link to={`${url}/documents`}>
          <Button type="primary">Documents</Button>
        </Link>
      </div>
      <Switch>
        <Route
          path={`${path}/documents`}
          render={(routeProps) => (
            <RetainerClientDocuments
              {...routeProps}
              documents={retainerClient.documents.filter((entry) => entry.uploaded)}
            />
          )}
        />
        <Route
          path={`${path}/meetings/create`}
          render={(routeProps) => (
            <NewRetainerClientMeetingMinutesForm
              {...routeProps}
              ongoingAssignments={retainerClient.assignments.filter(
                (entry) => !entry.endDate && entry.approvalStatus === 'accepted',
              )}
            />
          )}
        />
        <Route path={`${path}/assignment/:assignmentId/discussions`} component={DiscussionGroupPage} />
        <Route
          path={`${path}`}
          render={(routeProps) => <ClientDashboardPage retainerClient={retainerClient} {...routeProps} />}
        />
      </Switch>
    </div>
  );
};

RetainerClientLayout.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    retainerClient: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default graphql(QUERY, {
  options: ({ match }) => ({
    variables: { clientId: parseInt(match.params.clientId, 10) },
  }),
})(RetainerClientLayout);



// WEBPACK FOOTER //
// ./src/layouts/RetainerClientLayout.jsx